<template lang="pug">
  div#app
    div(
      v-if="loader.status",
      v-loading="loader.status",
      v-loading.fullscreen.lock="true",
      :element-loading-text="loader.text",
    )
    div
      router-view
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',

  computed: {
    ...mapState({
      loader: state => state.loader
    })
  }
}
</script>

<style lang="scss">

  * {
    box-sizing: border-box;
    font-family: 'Ubuntu', sans-serif;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #909399;
  }

  body, #app {
    width: 100%;
    height: 100%;
    position: absolute;
    margin: 0;
    padding: 0;
  }

  .extra-margin-top-bottom {
    margin-top: 30px;
    bottom: 30px;
  }

  .extra-margin-top {
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue